import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { DrilldownHeader } from '@components/DrilldownHeader';

import { LEGAL } from '@constants/routes';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import LegalSurvey from './LegalSurvey';

const messages = defineMessages({
  title: {
    id: 'organDonation.title',
    defaultMessage: 'Organ Donation',
  },
  subtitle: {
    id: 'organDonation.subtitle',
    defaultMessage: 'What organs are you willing to donate?',
  },
});

const OrganDonation: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <AppLayout friendlyName={formatMessage(messages.title)}>
      <DrilldownHeader
        backRoute={LEGAL}
        subtitle={formatMessage(messages.subtitle)}
        title={formatMessage(messages.title)}
      />
      <MainContainer maxWidth="600px">
        <LegalSurvey questionId="specific-organs" />
      </MainContainer>
    </AppLayout>
  );
};

export default OrganDonation;
